module.exports = __webpack_public_path__ + "15f32b7e7bd8cf544c4e3c1a81152a22.jpg";